export const IssueAggregateType = Object.freeze({
  TERMS: 0,
  HISTOGRAM: 1,
  RANGE: 2,
  PERCENTILES: 3,
  AVG: 4,
  MULTI_TERMS: 5,
});
